import React, { useState } from "react";
import { Mail } from "lucide-react";

import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "./assets/white-logo-transparent.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const pages = ["Home", "Get Matched", "Work", "About"];

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        <img src={logo} alt="Kaya logo" />
      </Link>

      <button className="navbar-toggle" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? "✖" : "☰"}
      </button>

      <ul className={`navbar-links ${isOpen ? "open" : ""}`}>
        {pages.map((txt) => (
          <li key={txt}>
            <Link
              to={txt === "Home" ? "/" : `/${txt.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setIsOpen(false)}
            >
              {txt}
            </Link>
          </li>
        ))}
        <li>
          <a
            href="mailto:hello@kayavisuals.com"
            className="navbar-contact"
            onClick={() => setIsOpen(false)}
            title="Email us"
          >
            <Mail size={20} strokeWidth={1.5} />
          </a>
        </li> 

      </ul>
    </nav>
  );
}
